module.exports = __webpack_public_path__ + "files/dbc719d3f7b29b2f8ea71014fdbee0e3.png";